module.exports = __webpack_public_path__ + "static/media/circutTraining.5325a945.svg";